module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.abb92af7.woff2";